import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.productDependency.name.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "productDependenciesSearch",
  fields: [
    name
  ]
}
